import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-padron-import-help-dialog',
  templateUrl: './padron-import-help-dialog.component.html',
  styleUrls: ['./padron-import-help-dialog.component.scss']
})
export class PadronImportHelpDialogComponent {
  constructor(public dialogRef: MatDialogRef<PadronImportHelpDialogComponent>) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
